import React, { useState } from "react";
import PageTitle from "@cs/components/src/PageTitle";
import { PageWrapperTwoColumn } from "@cs/components/src/PageWrapper";
import Input from "@cs/components/src/Input";
import { Check } from "react-feather";
import Button from "@cs/components/src/Button";
import { useMutation, useQueryClient } from "react-query";
import ApiService from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { useUpdateComponentsJob } from "../../context/UpdateComponentsJobContext";
import Select from "@cs/components/src/Select";

const ConfigureOrganizationCreateScreen = () => {
  const [appId, setAppId] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [baseUrl, setBaseUrl] = useState("app.iconik.io");
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { addComponentsJob } = useUpdateComponentsJob();

  const organizationMutation = useMutation({
    mutationFn: () =>
      ApiService.fetch<{
        data: { scriptExecutionId: string; systemDomainId: string };
      }>("POST", `/api/config/organization`, {
        appId,
        authToken,
        baseUrl,
      }),
    onSuccess: (res) => {
      addComponentsJob(
        res.data.scriptExecutionId,
        res.data.systemDomainId,
        "Updating components"
      );
      queryClient.invalidateQueries({ queryKey: ["organizationList"] });
      navigate(`/config/organization`);
    },
  });

  return (
    <div>
      <PageTitle
        title="Import Organization"
        previousRoute="/config/organization"
        previousTitle="Organizations"
        error={
          organizationMutation.isError
            ? (organizationMutation.error as Error).message ?? "Import failed"
            : undefined
        }
      >
        <Button
          label="Submit"
          icon={Check}
          onClick={() => organizationMutation.mutate()}
          loading={organizationMutation.isLoading}
          type="success"
        />
      </PageTitle>

      <PageWrapperTwoColumn>
        <Input label="App ID" value={appId} onChange={setAppId} />
        <Input label="Auth Token" value={authToken} onChange={setAuthToken} />
        <Select
          label="Base URL"
          value={baseUrl}
          onChange={({ value }) => setBaseUrl(value ?? "")}
          options={[
            { label: "app.iconik.io", value: "app.iconik.io" },
            { label: "app.aws.iconik.io", value: "app.aws.iconik.io" },
          ]}
        />
      </PageWrapperTwoColumn>
    </div>
  );
};

export default ConfigureOrganizationCreateScreen;
